module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title title",
    staticStyle: {
      "color": "#959FA9"
    }
  }, [_vm._v(" Detalle de pedido ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title title"
  }, [(_vm.window.width > 610) ? _c('span', {
    staticClass: "table-btn-icon icon-space"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("formatDate")(this.$route.params.filterOrdereDate.shippingDate, 'DD/MM/YYYY')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-header",
    staticStyle: {
      "height": "80px !important"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'OrdersProgress',
        params: {
          lastSearch: true,
          showAdvance: this.$route.params.showAdvanceMain
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success btnAction btn-search",
    staticStyle: {
      "background-color": "#E2E4E6",
      "border": "none",
      "height": "48px !important",
      "margin-bottom": "30px",
      "width": "130px !important"
    }
  }, [_c('img', {
    staticClass: "icon-space",
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/ic_back.png"
    }
  }), _vm._v("Regresar")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "box box-success"
  }, [_c('div', {
    staticClass: "box-header title-boreder"
  }, [_c('h3', {
    staticClass: "box-title box-title-sub"
  }, [_c('img', {
    staticStyle: {
      "padding-bottom": "7px"
    },
    attrs: {
      "src": "/static/img/icons/ic_doc2.png"
    }
  }), _vm._v(" Detalle: " + _vm._s(_vm._f("formatDate")(this.$route.params.filterOrdereDate.shippingDate, 'DD/MM/YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "filterContainer"
  }, [_c('div', {
    staticClass: "row title-boreder",
    staticStyle: {
      "padding-bottom": "25px"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.window.width > 610) ? _c('div', {
    staticClass: "col-xs-1"
  }) : _vm._e(), _vm._v(" "), (_vm.window.width <= 610) ? _c('div', {
    staticClass: "col-xs-9",
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    class: 'progress-bar',
    style: ('background-color:#536DFE;width:' + this.$route.params.filterOrdereDate.totalShippedPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  }), _vm._v(" "), _c('div', {
    class: 'progress-bar',
    style: ('background-color:#63CB68;width:' + this.$route.params.filterOrdereDate.totalProgressPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  }), _vm._v(" "), _c('div', {
    class: 'progress-bar',
    style: ('background-color:#4FC3F7;width:' + this.$route.params.filterOrdereDate.totalPendingPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.window.width > 610) ? _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    class: 'progress-bar',
    style: ('background-color:#536DFE;width:' + this.$route.params.filterOrdereDate.totalShippedPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  }), _vm._v(" "), _c('div', {
    class: 'progress-bar',
    style: ('background-color:#63CB68;width:' + this.$route.params.filterOrdereDate.totalProgressPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  }), _vm._v(" "), _c('div', {
    class: 'progress-bar',
    style: ('background-color:#4FC3F7;width:' + this.$route.params.filterOrdereDate.totalPendingPorcentage + '%'),
    attrs: {
      "role": "progressbar"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    staticStyle: {
      "padding-left": "10px",
      "position": "relative",
      "top": "-10px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("formatAmount")(this.$route.params.filterOrdereDate.orderTotal)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.params.filterOrdereDate.minimumStockUnit))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "display": "block"
    }
  }, [_vm._v("total")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.window.width > 610) ? _c('div', {
    staticClass: "col-xs-1"
  }) : _vm._e(), _vm._v(" "), (_vm.window.width <= 610) ? _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "border-right": "3px solid #F4F6F7",
      "margin-left": "15px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    style: ('background-color:#536DFE;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;')
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("formatAmount")(this.$route.params.filterOrdereDate.orderCompleted)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.params.filterOrdereDate.minimumStockUnit))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "display": "block"
    }
  }, [_vm._v("Atendidos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "color": "#536DFE",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(this.$route.params.filterOrdereDate.totalShippedPorcentage)) + "%")])])])]) : _vm._e(), _vm._v(" "), (_vm.window.width > 610) ? _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "border-right": "3px solid #F4F6F7"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    style: ('background-color:#536DFE;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;')
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("formatAmount")(this.$route.params.filterOrdereDate.orderCompleted)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.params.filterOrdereDate.minimumStockUnit))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "display": "block"
    }
  }, [_vm._v("Atendidos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', {
    staticStyle: {
      "color": "#536DFE",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(this.$route.params.filterOrdereDate.totalShippedPorcentage)) + "%")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "border-right": "3px solid #F4F6F7"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    style: ('background-color:#63CB68;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;')
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("formatAmount")(this.$route.params.filterOrdereDate.orderProgress)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.params.filterOrdereDate.minimumStockUnit))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "display": "block"
    }
  }, [_vm._v("Proceso")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "color": "#63CB68",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(this.$route.params.filterOrdereDate.totalProgressPorcentage)) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "border-right": "3px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    style: ('background-color:#4FC3F7;display:inline-block;width:2em;height:2em;line-height:2em;top:10px;')
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("formatAmount")(this.$route.params.filterOrdereDate.orderPending)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "font-size": "12px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.$route.params.filterOrdereDate.minimumStockUnit))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#4E6982",
      "display": "block"
    }
  }, [_vm._v("Pendientes")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "color": "#4FC3F7",
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(this.$route.params.filterOrdereDate.totalPendingPorcentage)) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    staticStyle: {
      "padding-left": "10px",
      "position": "relative",
      "top": "-10px"
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "ordersDetail"
    }
  }, [_c('Vuetable', {
    key: _vm.tableKey,
    ref: "vuetable",
    attrs: {
      "id": "ordersDetail",
      "api-mode": false,
      "fields": _vm.tableDetail,
      "css": _vm.tableCSS.table,
      "noDataTemplate": "No se encontraron resultados",
      "data": _vm.orderDetailTableVue,
      "data-manager": _vm.dataManager,
      "pagination-path": "pagination"
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData
    },
    scopedSlots: _vm._u([{
      key: "clientName",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Cliente"
          }
        }, [_c('span', [_vm._v(_vm._s(props.rowData.clientName))])])]
      }
    }, {
      key: "completedOrders",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Atendido"
          }
        }, [_c('div', {
          style: ('display: inline-flex;')
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 16px ;margin:-3px 25px 0 -10px;color:#4E6982;')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.completedPercentage)) + "%")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "50px",
            "margin-top": "0px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar percentageA",
          style: ('background-color:#D9DEFB')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#536DFE;width:' + props.rowData.completedPercentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-22px  0 0 190px;color:#506A83')
        }, [_c('span', {
          staticStyle: {
            "font-size": "16px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.completedOrders)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }, {
      key: "progressOrders",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Proceso"
          }
        }, [_c('div', {
          staticClass: "pendiente",
          style: ('display: inline-flex;')
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 16px ;margin:-3px 25px 0 -10px;color:#4E6982;')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.progressPercentage)) + "%")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "60px",
            "margin-top": "0px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar",
          style: ('background-color:#B6F5BB')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#63CB68;width:' + props.rowData.progressPercentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-22px  0 0 200px;color:#4E6982')
        }, [_c('span', {
          staticStyle: {
            "font-size": "16px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.progressOrders)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }, {
      key: "pendingOrders",
      fn: function(props) {
        return [_c('div', {
          attrs: {
            "id": "Pendientes"
          }
        }, [_c('div', {
          staticClass: "pendiente",
          style: ('display: inline-flex;')
        }, [_c('div', {
          staticClass: "progressContainer"
        }, [_c('div', {
          staticClass: "porcentajeTotal",
          style: ('font-size: 16px ;margin:-3px 25px 0 -10px;color:#4E6982;')
        }, [_vm._v(_vm._s(_vm._f("currency")(props.rowData.pendingPercentage)) + "%")]), _vm._v(" "), _c('div', {
          staticClass: "progressBar",
          staticStyle: {
            "position": "absolute !important",
            "margin-left": "60px",
            "margin-top": "0px"
          }
        }, [_c('div', {
          staticClass: "progress table-bar",
          style: ('background-color:#C6E9F8')
        }, [_c('div', {
          class: 'progress-bar progress-bar',
          style: ('background-color:#4FC3F7;width:' + props.rowData.pendingPercentage + '%'),
          attrs: {
            "role": "progressbar",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "totalPorcentaje",
          style: ('margin:-22px  0 0 200Px;color:#4E6982')
        }, [_c('span', {
          staticStyle: {
            "font-size": "16px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(_vm._f("formatAmount")(props.rowData.pendingOrders)))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "font-size": "14px",
            "font-weight": "bold",
            "color": "#4E6982"
          }
        }, [_vm._v(_vm._s(props.rowData.minimumStockUnit))])])])])])]
      }
    }])
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n           \n          "), (this.paginationData && _vm.paginationData.total > 0) ? [_c('strong', {
    staticStyle: {
      "color": "#364A5D",
      "paddin-left": "15px"
    }
  }, [_vm._v("\n            Mostrando documento " + _vm._s(this.paginationData.from) + " a " + _vm._s(this.paginationData.to) + " de " + _vm._s(this.paginationData.total) + " en Total\n            ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.tableCSS.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-199fe0bb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrdersProgressDetail.vue
// module id = 500
// module chunks = 1